import { rcEnums } from 'types/rc.enums';

const SPORT_ICON_PREFIX = 'icn-sport-';

export interface SportIcon {
	sport: number;
	// The path of the sport icon
	path: string;
}

/**
 *
 *
 * @param sportIconPath
 */
export function getSportComponent(sportIconPath: string) {
	let svgIcon;
	try {
		svgIcon = require(`public/media/icons/sport/${sportIconPath}`);
	} catch {
		svgIcon = require(`public/media/icons/sport/icn-sport-other.svg`);
	}

	if (svgIcon) {
		return svgIcon.ReactComponent;
	}

	return null;
}

export function getSportName(sport: number) {
	return rcEnums.shared.SportsEnum[sport];
}

/**
 *
 * @param sport
 */
export function getSportIconPath(sport: number) {
	const sportName = rcEnums.shared.SportsEnum[sport];

	if (!sportName) {
		return null;
	}

	const iconPath = `${SPORT_ICON_PREFIX}${sportName.toLowerCase().replace('_', '-')}.svg`;

	return iconPath;
}

/**
 *
 * @param sports - Array of sports id
 */
export function getSportsIconsNames(sports: number[]): SportIcon[] {
	return sports.reduce((accumulator: SportIcon[], currentSport: number) => {
		const iconPath = getSportIconPath(currentSport);

		if (iconPath && getSportComponent(iconPath)) {
			accumulator.push({ sport: currentSport, path: iconPath });
		}

		return accumulator;
	}, []);
}
